<template>
    <div>
        <vue-element-loading :active="isLoading" is-full-screen text="Please wait..." />
        <div >
            <lineChart
                :chart-data="lineChartData"
                class="chart-height"
            ></lineChart>
        </div>
    </div>
</template>

<script>
import LineChart from '@/components/chart/lineChart.vue';
export default {
    components: {
        LineChart
    },
    data() {
        return {
            type: this.$route.query.type,
            report_id: '',
            db_model: 'db',
            lineChartData: {
                labels: [],
                datasets: []
            },
            isLoading: false,
            // isLoading2: false,
        }
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.report_id = report.id;
        this.getReport()
    },
    methods: {
        getReport() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/psd`;
            const json = {
                report_id: this.report_id,
                client_account: '1'
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    const jsonData = JSON.parse(res.data.data);
                    this.drawPulse(jsonData.row);
                }
                this.isLoading = false
            })
        },
        drawPulse(pulse) {
            let pulseAry = [];
            let labAry = [];
            pulseAry = pulse;
            
            pulseAry.splice(0, 1);
            pulse = pulseAry.join(",");
            pulseAry.forEach((item, i) => {
                labAry.push(i);
            })
            
            let result = {
                labels: labAry,
                datasets: [
                {
                    label: 'PSD',
                    backgroundColor: "transparent",
                    data: pulseAry,
                    borderColor: "rgba(29, 33, 36, .2)",
                    pointBackgroundColor: "rgba(171, 71, 188, 1)",
                    pointRadius: 1,
                }
                ]
            };
            this.lineChartData = result;
        },
    }
}
</script>